import React from 'react';

import PageMap from '../PageMap';

import { updateContent } from '../../utils/html';

import './styles.css';
import './styles/texts.css';
import './styles/blockquotes.css';
import './styles/highlights.css';
import './styles/others.css';

const ContentContainer = ({ data, content, changePage }) => {
    if (!content || !content.sections) return <></>;

    return (
        <div className='ncs-content-container'>
            {content.sections.map((section) => (
                <section key={section.slug} id={section.slug}>
                    {content.sections.length > 1 && section.title && (
                        <div className='ncs-section-title'>
                            <div className='ncs-section-icon'>
                                <img src={section.icon} alt='' />
                            </div>
                            <h2 className='ncs-section-title'>
                                {section.title}
                            </h2>
                        </div>
                    )}
                    <div
                        className='ncs-section-content'
                        dangerouslySetInnerHTML={{
                            __html: updateContent(section.content, content),
                        }}
                    ></div>
                </section>
            ))}
            {content.island === 'Navegar com Segurança' && (
                <PageMap
                    data={data}
                    content={content}
                    changePage={changePage}
                />
            )}
        </div>
    );
};

export default ContentContainer;
